import { v4 as uuid } from 'uuid';

/**
 *
 * @param {string} prefix
 * @returns {string} unique id like `{prefix}-{generated id}`
 */
export const getUniqueIdWithPrefix = (prefix = '') => `${prefix ? prefix + '-' : ''}${uuid().slice(-6)}`
